import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomination-sanction-form',
  templateUrl: './nomination-sanction-form.component.html',
  styleUrls: ['./nomination-sanction-form.component.css']
})
export class NominationSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Nomination/nomination-sanction/nomination-sanction-form/nomination-sanction-form.component.ts